var React = require('react');

function ArrowLeftCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#000"},React.createElement("g",{"transform":"translate(-74 -1067) translate(75 1068)"},[React.createElement("circle",{"cx":"28","cy":"28","r":"28","opacity":".11","key":0}),React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1},React.createElement("path",{"d":"M0 6L16 6M10 0L16 6 10 12","transform":"matrix(-1 0 0 1 36 23)"}))]))));
}

ArrowLeftCircle.defaultProps = {"width":"58","height":"58","viewBox":"0 0 58 58"};

module.exports = ArrowLeftCircle;

ArrowLeftCircle.default = ArrowLeftCircle;
